import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

const postCardVariables = {
  desktop_breakpoint_width: 1024,
};

const PostCardStyles = styled.div`
  border: ${(props) => (props.showImage ? `solid 1px #f5f5f5` : '0')};
  padding: 16px;

  .post-image-container {
    display: none;
    text-align: center;
  }
  .post-card-info {
    position: relative;

    .bookmark-container {
      position: absolute;
      top: 0;
      right: 0;
      .tooltip {
        left: ${(props) => (props.bookmarkPlacement === 'top' ? -30 : 5)}px;
        top: ${(props) => (props.bookmarkPlacement === 'top' ? -36 : -3)}px;
      }
    }
    .category-tag {
      color: ${Colors.grayscaleCoolGray06};
      font-family: 'source-sans-pro', sans-serif;
      font-size: 13px;
      font-weight: 600;
    }
    .heading-component {
      h4 {
        font-size: 18px;
        height: 90px;
        letter-spacing: normal;
        line-height: 1.28;
        margin-block-start: 0;
        margin-block-end: 0;
        max-width: ${(props) => (props.largeCard ? 'none' : '92%')};
      }
    }
  }

  @media screen and (min-width: ${postCardVariables.desktop_breakpoint_width}px) {
    max-width: 100%;
    height: ${(props) => (props.largeCard ? '613px' : 'auto')};

    .post-image-container {
      background-color: #ccc;
      margin-bottom: 15px;
      height: ${(props) => (props.largeCard ? 423 : 170)}px;
      overflow: hidden;
      display: ${(props) => (props.showImage ? 'block' : 'none')};
      width: 100%;
      position: relative;

      img {
        height: 100%;
        margin: 0 auto;
        width: auto;
        object-fit: cover;
        object-position: left;
      }
    }
    .post-card-info {
      .heading-component {
        h4 {
          font-size: ${(props) => (props.largeCard ? 28 : 18)}px;
        }
      }
    }
  }
`;

export default PostCardStyles;
